var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AccountUtils from '@popup/steem/utils/account.utils';
import { GovernanceUtils } from '@popup/steem/utils/governance.utils';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
const findUserProxy = (user) => __awaiter(void 0, void 0, void 0, function* () {
    const previousChecked = [user.name];
    if (user.proxy.length === 0)
        return null;
    else {
        let proxy = user.proxy;
        do {
            if (previousChecked.includes(proxy))
                return null;
            previousChecked.push(proxy);
            proxy = (yield AccountUtils.getExtendedAccount(proxy)).proxy;
        } while (proxy.length !== 0);
        return previousChecked[previousChecked.length - 1];
    }
});
const setAsProxy = (proxyName, username, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    GovernanceUtils.removeFromIgnoreRenewal(username);
    return yield SteemTxUtils.sendOperation([getSetProxyOperation(proxyName, username)], activeKey, false, options);
});
const getSetProxyOperation = (proxyName, username) => {
    return [
        'account_witness_proxy',
        { account: username, proxy: proxyName },
    ];
};
const getSetProxyTransaction = (proxyName, username) => {
    return SteemTxUtils.createTransaction([
        ProxyUtils.getSetProxyOperation(proxyName, username),
    ]);
};
const removeProxy = (username, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    return setAsProxy('', username, activeKey, options);
});
const ProxyUtils = {
    findUserProxy,
    setAsProxy,
    removeProxy,
    getSetProxyOperation,
    getSetProxyTransaction,
};
export default ProxyUtils;
